import { AccountingLocationGroups } from '@app/transfer-in/page';

import { AccountingLocationType, BranchCashOverviewResponseResponse } from '@api/generator';
import { BranchCashOverview } from '@api/generator';

export const accountingLocationTypeToText = (accountingLocationType: string) => {
  switch (accountingLocationType) {
    case 'cashDrawer':
      return 'Cash Drawer';
    case 'safe':
      return 'Safe';
    default:
      return 'Unknown';
  }
};

export const constructAccountingLocationBarcode = (fadcode: string, accountingLocationId: string) =>
  `${fadcode}-${accountingLocationId}`;

export const accountingLocationName = (accountingLocationName: string) => {
  if (accountingLocationName === 'Safe 1') return 'Safe';
  return accountingLocationName;
};

export const getLegacyAccountingLocationType = (accountingLocationType: AccountingLocationType) => {
  switch (accountingLocationType) {
    case 'cashDrawer':
      return 'cash_drawer';
    case 'safe':
      return 'safe';
    default:
      return '';
  }
};

// Adds the counterTerminal option
type ExtendedAccountingLocationType = 'cashDrawer' | 'safe' | 'counterTerminal';

export const getExtendedAccountingLocationType = (
  accountingLocation: BranchCashOverview,
): ExtendedAccountingLocationType => {
  if (accountingLocation.accountingLocationType === 'safe') return 'safe';
  if (accountingLocation.counterID) return 'counterTerminal';
  return 'cashDrawer';
};

export const getSelectableAccountingLocationList = (
  branchOverviewData: BranchCashOverviewResponseResponse | undefined,
  currentAccountingLocation: string,
) => {
  const accountingLocationGroups: AccountingLocationGroups = {
    safe: [],
    cashDrawer: [],
    counterTerminal: [],
  };

  if (!branchOverviewData) return accountingLocationGroups;

  branchOverviewData.forEach((accountingLocation) => {
    // Filter out the current accounting location as we're only interested in the other ones
    if (accountingLocation.accountingLocationID === currentAccountingLocation) return;

    const accountingLocationType = getExtendedAccountingLocationType(accountingLocation);
    accountingLocationGroups[accountingLocationType].push(accountingLocation);
  });

  return accountingLocationGroups;
};

export const formatCounterTerminalName = (accountingLocation: BranchCashOverview) => {
  if (!accountingLocation?.counterID) {
    return accountingLocationName(accountingLocation?.accountingLocationName);
  }

  return `Counter Terminal ${accountingLocation.counterID} (${accountingLocation.accountingLocationName})`;
};

// Format of accountingLocationID is C01 (cash drawer) or S01 (safe)
export const accountingLocationTypeFromId = (
  accountingLocationID: string,
): 'safe' | 'cashDrawer' => {
  if (accountingLocationID.includes('S')) return 'safe';
  return 'cashDrawer';
};

// Format of accountingLocationID is C01 (cash drawer) or S01 (safe)
export const accountingLocationNumberFromID = (accountingLocationID: string) =>
  accountingLocationID.substring(1);

// Doesn't use translation files as these need to match the accounting location names coming from the APIs, which is currently only in English.
// We should in future update this function to use a translation file and never use the accounting location names from the API - instead construct
// them using this function to ensure consistency
export const accountingLocationNameFromID = (accountingLocationID: string) => {
  if (accountingLocationID.includes('S')) return 'Safe';
  return `Cash Drawer ${Number(accountingLocationID.substring(1))}`;
};
